import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';

const { width } = useWindowSize();

/**
 * 计算布局长度的代称
 * @returns
 */
export const usePageResize = () => {
  const widthConfig = {
    xxl: 1536,
    xl: 1280,
    md: 1024,
    lg: 768
  };
  const widthType = computed(() => {
    if (width.value > widthConfig.xxl) {
      return 'xxl';
    } else if (width.value <= widthConfig.xxl && width.value > widthConfig.xl) {
      return 'xl';
    } else if (width.value <= widthConfig.xl && width.value > widthConfig.md) {
      return 'md';
    } else if (width.value <= widthConfig.md && width.value > widthConfig.lg) {
      return 'lg';
    } else {
      return 'sm';
    }
  });
  const isMobile = computed(() => {
    return width.value <= widthConfig['md'];
  });

  return { widthType, width, widthConfig, isMobile };
};
